import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, font } = theme.custom;
    return {
        container: { maxHeight: 'calc(100vh - 300px)' },
        mono: { fontFamily: font.mono, fontSize: 13, whiteSpace: 'nowrap' },
        numeric: { textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
        name: { fontWeight: 600 },
        email: { overflowWrap: 'anywhere' },
        countLink: {
            fontWeight: 600,
            color: color.primary.main,
            textDecoration: 'none',
            fontVariantNumeric: 'tabular-nums',
            '&:hover': { textDecoration: 'underline' },
        },
    };
});
